<template>
    <div class="conf-con">
     <div class="intro-pic">
        <img src="../../../assets/images/14.jpg" alt="">
      </div>
        <p class="intro-tit">中国共产党第十四次全国代表大会简介</p>
        <p class="margin1">1992年10月12日至19日在北京举行。江泽民作《加快改革开放和现代化建设步伐，夺取有中国特色社会主义事业的更大胜利》的报告。大会确立邓小平建设有中国特色社会主义理论在全党的指导地位，概括了建设有中国特色社会主义理论的主要内容，明确建立社会主义市场经济体制的改革目标，要求全党抓住机遇，加快发展，集中精力把经济建设搞上去。大会通过了《关于十三届中央委员会报告的决议》、《关于中央顾问委员会工作报告的决议》、《关于中央纪律检查委员会工作报告的决议》和《关于〈中国共产党章程修正案〉的决议》。大会选举了由189名委员和130名候补委员组成的中央委员会，选举了由108名委员组成的中央纪律检查委员会。随后召开的十四届一中全会选举了中央政治局及其常务委员会；选举江泽民为中央委员会总书记；决定江泽民为中央军事委员会主席；批准尉健行为中央纪律检查委员会书记。</p>
         </div>
</template>

<script>
export default {

}
</script>

<style>

</style>